import Flux from 'lib/flux';
import BookingDetailsConstants from 'constants/booking_details';
import BookingRequestConstants from 'constants/booking_request';
import IntegrationConstants from 'constants/integration';
import ViewportConstants from 'constants/viewport';
import { Theme } from 'ui_system/theme';

export default Flux.createStore({
  name: 'booking_details',

  layoutNeeded() {
    if (
      window.matchMedia(
        `only screen and (max-width: ${Theme.mobile.phoneWidth - 1}px)`
      ).matches
    ) {
      return 'tablet';
    }
    return 'desktop';
  },

  getInitialState() {
    return {
      guests: 2,
      addons: [],
      time: null,
      showDates: false,
      hidden: this.layoutNeeded() === 'tablet',
      layoutNeeded: this.layoutNeeded(),
      originUrl: window.location.href,
    };
  },

  actions: [
    [
      IntegrationConstants.UPDATE_ORIGIN_URL,
      function (url) {
        this.state = this.state.set('originUrl', url);
      },
    ],

    [
      BookingRequestConstants.CHANGE,
      function (fields) {
        this.state = this.state.merge({
          guests: fields.guests,
          addons: fields.addons,
          time: fields.time,
        });
      },
    ],

    [
      BookingDetailsConstants.SHOW_DATES,
      function () {
        this.state = this.state.set('showDates', true);
      },
    ],

    // XXX: These actions are used as a toggle. Would like to refactor.
    [
      BookingDetailsConstants.DATES_SHOWN,
      function () {
        this.state = this.state.set('showDates', false);
      },
    ],

    [
      BookingDetailsConstants.SHOW_FORM,
      function () {
        this.state = this.state.set('hidden', false);
      },
    ],

    [
      ViewportConstants.RESIZED,
      function () {
        const oldLayoutNeeded = this.state.get('layoutNeeded');
        this.state = this.state.set('layoutNeeded', this.layoutNeeded());
        if (oldLayoutNeeded !== this.state.get('layoutNeeded')) {
          this.state = this.state.set(
            'hidden',
            this.layoutNeeded() == 'tablet'
          );
        }
      },
    ],
  ],
});
